module.exports = __webpack_public_path__ + "OpenSans-SemiBold.1edcff1832faff8383e0.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-SemiBold.woff2
// module id = ../../../../../src/assets/customfonts/OpenSans-SemiBold.woff2
// module chunks = styles